import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import UserDetails from "../ui/UserDetails"
import { fetchUsers } from "../../store/users"
import "../styles/AdminUserPage.css"

function AdminUserPage() {
  const { users } = useSelector((state) => state.users)
  const [selectedUser, setSelectedUser] = useState(null)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchUsers())
  }, [dispatch])

  return (
    <div className="admin-user-page-container">
      <div className="admin-user-page-section">
        <h2 className="admin-user-page-heading">Users</h2>
        <h2 className="admin-user-page-heading">
          Select a User to View Orders, Carts, and Reviews.
        </h2>
        <div className="admin-user-table-container">
          <table className="admin-user-table">
            <thead className="admin-user-table-header">
              <tr>
                <th></th>
                <th>Username</th>
                <th>Email</th>
                <th>Joined</th>
                <th>Admin</th>
                <th>Stripe ID</th>
                <th>Orders</th>
              </tr>
            </thead>
            <tbody>
              {users.length > 0 &&
                users.map((user) => (
                  <tr
                    key={user.id}
                    className="admin-user-table-row"
                    onClick={() => setSelectedUser(user)}
                  >
                    <th>
                      <div className="admin-user-avatar">
                        <img src={user.avatar} alt={user.username} />
                      </div>
                    </th>
                    <td>{user.username}</td>
                    <td>{user.email}</td>
                    <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                    <td>{user.isAdmin ? "TRUE" : "FALSE"}</td>
                    <td>{user.stripeId}</td>
                    <td>{user.orders ? user.orders.length : 0}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="admin-user-details-section">
        <UserDetails user={selectedUser} />
      </div>
    </div>
  )
}

export default AdminUserPage
